import { Routes, Route } from "react-router-dom";

import StDocsHome from "./StDocsHome";
import StDocPage from "./StDocPage";

const StDocs = () => {
    return (
        <div>
            <Routes>
                <Route path="/" element={<StDocsHome />} />
                <Route path="/:docSlug" element={<StDocPage />} />
            </Routes>
        </div>
    );
};

export default StDocs;
